/*
 * action types
 */
export const SET_SCORE = 'SET_SCORE';
export const SET_BACKGROUND = 'SET_BACKGROUND';
export const CREATE_POLL = 'CREATE_POLL';
export const DELETE_POLL = 'DELETE_POLL';
export const FETCH_POLL_STATE_FB = 'FETCH_POLL_STATE_FB';
export const SYNC_POLL_STATE_FB = 'SYNC_POLL_STATE_FB';
export const RESULTS_VIEW_IS_BUBBLES = 'RESULTS_VIEW_IS_BUBBLES';
